import http from './http';

class PromoService {  
    public static registerOneTimePromo = (info: any) => {
      return http.post(`/one-time-promo/`, { ...info });
    };
}

export default PromoService;